import { createComponent } from '@carvana/merch-components';

export const HeroFavoriteAndSearchCard = createComponent('div', {
  className:
    'h-auto rounded-md border border-solid border-border-weak bg-background-default lg:h-full'
});

export const FinanceTradeWrapper = createComponent('div', {
  className:
    'col-span-1 grid grid-cols-1 gap-2xl sm:col-span-2 sm:grid-cols-2 lg:col-span-1 lg:grid-cols-1 lg:grid-rows-[1fr_1fr]'
});

export const GridWrapper = createComponent('div', {
  className: 'z-1 grid grid-cols-1 gap-2xl sm:grid-cols-2 lg:grid-cols-3'
});
